import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const entityToCategoryField = (entity: Entities) => {
  switch (entity) {
    case Entities.customer:
      return {
        kundenverteiler: true,
      };
    case Entities.supplier:
      return {
        lieferantenverteiler: true,
      };
    default:
      return {};
  }
};
